module.exports = __webpack_public_path__ + "img/3.693fba35.png";